import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const MaternalHealthIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path d="M8.6 3c0-1.2 1-2.2 2.2-2.2 1.2 0 2.3 1 2.3 2.2s-1 2.2-2.3 2.2c-1.2.1-2.2-1-2.2-2.2m7.9 10.1c0-1.5-.9-2.8-2.2-3.4 0-1.9-1.5-3.4-3.4-3.4a3.5 3.5 0 0 0-3.4 3.5v7.9h2.3v5.6h3.4v-5.6h3.4l-.1-4.6z" />
    </IconBase>
  );
};

export default MaternalHealthIcon;
